module.exports = __webpack_public_path__ + "img/fairbnb.f49fb3f6.png";